const BASE_URL_IMAGES = "https://raw.githubusercontent.com/Yarkis01/TyraDex/images/sprites/"
export const PLACEHOLDER_POKEMON = "/images/placeholder_pokemon_inconnu.svg"

/**
 * Renvoie l'URL du sprite Tyradex d'un pokémon à partir de son nom français,
 * ou le placeholder si le pokémon est introuvable dans window.listePokemons.
 * @param {string} nom
 * @returns {string}
 */
export function urlSpritePokemon(nom) {
  if (!nom) {
    return PLACEHOLDER_POKEMON
  }

  const nomNormalise = nom.toLowerCase().replace(/\s/g, "-").replace(/'/g, "-")
  const liste = Array.isArray(window.listePokemons) ? window.listePokemons : []
  const idPokemon = liste.find((pokemon) => pokemon?.name?.fr?.toLowerCase() === nomNormalise)?.pokedex_id

  return idPokemon ? `${BASE_URL_IMAGES}/${idPokemon}/regular.png` : PLACEHOLDER_POKEMON
}
